export default "__VITE_ASSET__CPcYWy18__";